'use strict';

import {
    Group, Mesh, MeshBasicMaterial, ShaderMaterial,
    TextureLoader,
} from 'three';
import cloudsVertex from '../threejs/Shaders/weather/clouds/vertexShader.glsl';
import cloudsFragment from '../threejs/Shaders/weather/clouds/fragmentShader.glsl';
import { PostFX } from '../post-processing/PostFX';
import { projectMode, threeJsVariables } from '../../settings';


export class Clouds {
    constructor () {

        if (projectMode.LiteMode.isActive()){
            this.active = false;
        } else {

            this.active = false;
            const url = './assets/textures/clouds/';

            const bg = threeJsVariables.scene.getObjectByName('Background');
            const textureLoader = new TextureLoader();

            this.clouds = new Group();
            this.clouds.name = 'clouds';

            this.clouds.position.copy(bg.position);
            this.clouds.scale.copy(bg.scale);
            this.clouds.rotation.copy(bg.rotation);

            this.clouds.position.y = config.features.weather?.settings?.clouds?.positionY || bg.position.y;

            bg.traverse(el => {
                if (el.isMesh){
                    const g = el.geometry.clone();
                    const m = new MeshBasicMaterial({
                        map: textureLoader.load(url + el.name + '.png'),
                        transparent: true
                    });

                    const mesh = new Mesh(g,m);
                    mesh.name = el.name;
                    this.clouds.add(mesh);
                }
            });

        }

        return this;
    }

    enable() {

        if (projectMode.LiteMode.isActive()) {
            projectMode.LiteMode.cloudsToggle('enable');
            this.active = true;
        } else {
            threeJsVariables.scene.add(this.clouds);
            this.active = true;
        }

    }

    disable() {

        if (projectMode.LiteMode.isActive()) {
            projectMode.LiteMode.cloudsToggle('disable');
            this.active = false;
        } else {

            this.active = false;
            this.clouds.removeFromParent();

            this.clouds.traverse(el => {
                if (el.isMesh){
                    el.material.map.dispose();
                    el.material.dispose();
                    el.geometry.dispose();
                }
            })
        }

    }

    update(time) {
        if (!projectMode.LiteMode.isActive()) {
            if (this.active) {
                this.clouds.rotation.y = this.clouds.rotation.y - 0.00015 ;
            }
        }
    }
}